export default __webpack_public_path__ + "static/media/tax-icon.3d8e701e.svg";